import { Injectable } from '@angular/core';
import { CancelCall, PhoneCallDetails, PhoneCallHistoryItem, QuoteActionCancel } from '../models/call';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PhonecallService {

  apiUrl = 'v1/call/';

  constructor(public http: HttpClient) {
    
  }

  public cancelCall(call: CancelCall) {
    return this.http.post(environment.ApiUrl() + this.apiUrl + "cancel", call);
  }

  public handleCall(call: CancelCall) {
    return this.http.post(environment.ApiUrl() + this.apiUrl + "handle", call);
  }

  public cancelQuoteAction(quoteId: number) {
    const dto: QuoteActionCancel = { quoteId };
    return this.http.post(environment.ApiUrl() + this.apiUrl + "quote_action/cancel", dto);
  }

  public assignDetailsToCall(phoneCallId: number, customerId: number, quoteId: number) {
    // Implementation for assigning details to a call
    const dto: PhoneCallDetails = {
      phoneCallId,
      customerId,
      quoteId
    };
    return this.http.post(environment.ApiUrl() + this.apiUrl + "assignDetails", dto);
  }

  public getCallHistory() {
    return this.http.get<PhoneCallHistoryItem[]>(environment.ApiUrl() + this.apiUrl + "history");
  }

}
